// Small shared helpers for the Manage Club tabs.

/** Error values from the services are a string, an Error or { message }. */
export { msg } from "../../lib/errors";

// [key, icon, label] straight from the mockup ADMIN_TABS.
export const ADMIN_TABS = [
  ["overview", "home", "Home"],
  ["editbio", "edit", "Bio"],
  ["events", "cal", "Events"],
  ["users", "users", "Members"],
  ["applications", "userplus", "Applications"],
  ["share", "qr", "Share"],
];
export const TAB_KEYS = ADMIN_TABS.map((t) => t[0]);

export const manageHref = (clubId, tab) =>
  !clubId ? "/manage" : tab && tab !== "overview" ? `/manage/${clubId}/${tab}` : `/manage/${clubId}`;

/** Server BULK_APPROVE_MAX is 100; chunk web-side so one call never exceeds it. */
export const BULK_CHUNK = 100;
export function chunk(arr, n) {
  const out = [];
  for (let i = 0; i < arr.length; i += n) out.push(arr.slice(i, i + n));
  return out;
}

/** Inline error card with Retry. */
export const ERR_TEXT = "Couldn't load this. Check your connection and try again.";
